export default __webpack_public_path__ + "static/media/jungle_2.3f41771d.jpg";